@if (isLoading) {
  <app-content-loader></app-content-loader>
}
@if (isInitialized) {
  <div class="step-container columns is-desktop">
    <app-aside-bar
      [showEvenWithoutStatement]="false"
      [statement]="statement"
      [workFlowController]="workFlowController"
    ></app-aside-bar>
    <div class="main-content__container confirm-tax-return">
      <app-ctr-base-info
        [statement]="statement"
        [title]="'CONFIRM_NEW_PREMIUM_AMOUNT.TITLE' | translate"
        [desc]="'CONFIRM_NEW_PREMIUM_AMOUNT.DESCRIPTION' | translate"
      ></app-ctr-base-info>
      <div class="price-container">
        <div class="text-section">
          <h3>Twoja płatność za usługę</h3>
          <span>Potwierdź zaktualizowaną cenę za usługę ustaloną przez doradcę.</span>
        </div>
        <app-payment-info [statement]="statement" [dataSelects]="dataSelects"> </app-payment-info>
      </div>
    </div>
    <app-tools-bar [statement]="statement" [buttons]="buttons"></app-tools-bar>
  </div>
}
